import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import BadgeAssignCreateLayer from "../components/BadgeAssignCreateLayer";

const BadgeAssignCreatePage = () => {
  return (
    <MasterLayout>
      <BadgeAssignCreateLayer />
    </MasterLayout>
  );
};

export default BadgeAssignCreatePage;
